import type { NavItem } from '@tourtask/types/navigation';

export function findNavItemByUrlCode(items: ReadonlyArray<NavItem>, urlCode: string): NavItem | undefined {
  for (const item of items) {
    if (item.urlCode === urlCode) {
      return item;
    }

    if (item.children) {
      const found = findNavItemByUrlCode(item.children, urlCode);
      if (found) return found;
    }
  }

  return undefined;
}